import React, {useEffect, useState} from 'react';
import Loading from '../components/Loading';
import './ShopPage.css';
import {Button, Col, Container, Form, Modal, Pagination, Row, Table} from "react-bootstrap";
import {getShop, updateShop} from "../services/ShopService";
import Swal from "sweetalert2";
import axios from "axios";
import {CloseLarge, RequestQuote, Search} from "@carbon/icons-react";
import {FiCopy} from "react-icons/fi";
import { useLocation } from 'react-router-dom';

export default function ShopPage() {
    const keyLocalStorage = 'authToken';
    const location = useLocation();
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorsShopBranch, setErrorsShopBranch] = useState({});
    const [errorsShopBranchEdit, setErrorsShopBranchEdit] = useState({});

    const [shopBranch, setShopBranch] = useState([]);

    const [showModalAddShopBranch, setShowModalAddShopBranch] = useState(false);
    const [showModalEditShopBranch, setShowModalEditShopBranch] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [currentNumberOfElements, setCurrentNumberOfElements] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const [isLoading, setIsLoading] = useState(true);

    const [nameFilter, setNameFilter] = useState("");

    //alta de sucursal
    const [nameShopBranch, setNameShopBranch] = useState('');
    const [registeredNameShopBranch, setRegisteredNameShopBranch] = useState('');
    const [addressShopBranch, setAddressShopBranch] = useState('');
    const [phoneNumberShopBranch, setPhoneNumberShopBranch] = useState('');
    const [provinceShopBranch, setProvinceShopBranch] = useState('');
    const [cityShopBranch, setCityShopBranch] = useState('');

    //edit de sucursal
    const [idShopBranchEdit, setIdShopBranchEdit] = useState('');
    const [nameShopBranchEdit, setNameShopBranchEdit] = useState('');
    const [registeredNameShopBranchEdit, setRegisteredNameShopBranchEdit] = useState('');
    const [addressShopBranchEdit, setAddressShopBranchEdit] = useState('');
    const [phoneNumberShopBranchEdit, setPhoneNumberShopBranchEdit] = useState('');
    const [provinceShopBranchEdit, setProvinceShopBranchEdit] = useState('');
    const [cityShopBranchEdit, setCityShopBranchEdit] = useState('');

    const [shopDTO, setShopDTO] = useState({
        id: null,
        name: '',
        address: '',
        phone: '',
        state: '',
        location: '',
        businessName: '',
        pathLogo: null,
        pathQr: null,
        principalColorShop: '',
        image: null,
        imageFormat: null,
        modules: [],
        uuid: ''
    })
    const [editShopDTO, setEditShopDTO] = useState({
        id: null,
        name: '',
        address: '',
        phone: '',
        state: '',
        location: '',
        businessName: '',
        pathLogo: null,
        pathQr: null,
        principalColorShop: '',
        image: null,
        imageFormat: null,
        modules: [],
        uuid: ''
    })

    // Estado para forzar la recarga cuando cambie el token
    const [tokenVersion, setTokenVersion] = useState(0);

    // Listener para detectar cambios en localStorage
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === keyLocalStorage) {
                setTokenVersion(prev => prev + 1);
            }
        };

        // Escuchar cambios en otros tabs
        window.addEventListener('storage', handleStorageChange);
        
        // Crear un observer para detectar cambios en el mismo tab
        const originalSetItem = localStorage.setItem;
        const originalRemoveItem = localStorage.removeItem;
        
        localStorage.setItem = function(key, value) {
            const oldValue = localStorage.getItem(key);
            originalSetItem.apply(this, arguments);
            if (key === keyLocalStorage && oldValue !== value) {
                // Usar setTimeout para asegurar que el cambio se procese después
                setTimeout(() => setTokenVersion(prev => prev + 1), 0);
            }
        };

        localStorage.removeItem = function(key) {
            originalRemoveItem.apply(this, arguments);
            if (key === keyLocalStorage) {
                setTimeout(() => setTokenVersion(prev => prev + 1), 0);
            }
        };

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            localStorage.setItem = originalSetItem;
            localStorage.removeItem = originalRemoveItem;
        };
    }, []);

    useEffect(() => {
        // Resetear el estado cuando cambie el token
        if (tokenVersion > 0) {
            setShopDTO({
                id: null,
                name: '',
                address: '',
                phone: '',
                state: '',
                location: '',
                businessName: '',
                pathLogo: null,
                pathQr: null,
                principalColorShop: '',
                image: null,
                imageFormat: null,
                modules: [],
                uuid: ''
            });
            setEditShopDTO({
                id: null,
                name: '',
                address: '',
                phone: '',
                state: '',
                location: '',
                businessName: '',
                pathLogo: null,
                pathQr: null,
                principalColorShop: '',
                image: null,
                imageFormat: null,
                modules: [],
                uuid: ''
            });
            setCurrentPage(1);
            setNameFilter("");
        }

        const getShopDTO = async() => {
            try {
                return await getShop(shopDTO);
            } catch (error) {
                throw error;
            }
        }

        getShopDTO()
            .then((data) => {
                setShopDTO(data);
                setEditShopDTO(data);
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                })
            })
            .finally(setLoading(false));

        getPage();

    }, [currentPage, isLoading, tokenVersion])

    // Efecto para detectar cuando se navega a la página
    useEffect(() => {
        // Forzar recarga cuando se navega a la página
        setTokenVersion(prev => prev + 1);
    }, [location.pathname]);

    const getPage = () => {
        axios.get(process.env.REACT_APP_API_SHOP_BRANCH_PAGE_ROUTE, {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            },
            params: {
                page: currentPage,
                name: nameFilter
            }
        })
            .then(response => {
                setShopBranch(response.data.content);
                setTotalPages(response.data.totalPages);
                setCurrentPage(response.data.number + 1);
                setCurrentNumberOfElements(response.data.numberOfElements)
                setTotalElements(response.data.totalElements)
            })
            .catch(error => {
                console.warn(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const handleCloseModal = () => {
        setShow(false);
        setTimeout(() => {
            setErrors({})
        }, 200);
    };
    const handleShowModal = () => {
        setEditShopDTO(shopDTO);
        setShow(true);
    }
    const handleValidation = () => {
        let tempErrors = {};
        let isValid = true;

        if (!editShopDTO.name || editShopDTO.name.trim() === "") {
            isValid = false;
            tempErrors["name"] = "El nombre de la tienda es requerido";
        }

        if (!editShopDTO.businessName || editShopDTO.businessName.trim() === "") {
            isValid = false;
            tempErrors["businessName"] = "La razón social es requerida";
        }

        if (!editShopDTO.phone || editShopDTO.phone.trim() === "") {
            isValid = false;
            tempErrors["phone"] = "El teléfono es requerido";
        }

        if (!editShopDTO.address || editShopDTO.address.trim() === "") {
            isValid = false;
            tempErrors["address"] = "La dirección es requerida";
        }

        if (!editShopDTO.state || editShopDTO.state.trim() === "") {
            isValid = false;
            tempErrors["state"] = "La localidad es requerida";
        }

        if (!editShopDTO.location || editShopDTO.location.trim() === "") {
            isValid = false;
            tempErrors["location"] = "La provincia es requerida";
        }

        setErrors(tempErrors);
        return isValid;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            updateShop(editShopDTO)
                .then((data) => {
                    Swal.fire({
                        icon: 'success',
                        text: 'Datos actualizados',
                    })
                    setShopDTO(data)
                    setEditShopDTO(data)
                    handleCloseModal()
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.message,
                    })
                })
        }
    };

    const paginationModule = () => {
        return (
            <Container fluid>
                <Row>
                    <Col className="d-flex align-items-center">
                        <Pagination>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1}/>
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)}
                                             disabled={currentPage === 1}/>
                            {currentPage > 2 && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage - 2)}>
                                    {currentPage - 2}
                                </Pagination.Item>
                            )}
                            {currentPage > 1 && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage - 1)}>
                                    {currentPage - 1}
                                </Pagination.Item>
                            )}
                            <Pagination.Item active>{currentPage}</Pagination.Item>
                            {currentPage < totalPages && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>
                                    {currentPage + 1}
                                </Pagination.Item>
                            )}
                            {currentPage < totalPages - 1 && (
                                <Pagination.Item onClick={() => handlePageChange(currentPage + 2)}>
                                    {currentPage + 2}
                                </Pagination.Item>
                            )}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)}
                                             disabled={currentPage === totalPages || shopBranch.length === 0}/>
                            <Pagination.Last onClick={() => handlePageChange(totalPages)}
                                             disabled={currentPage === totalPages || shopBranch.length === 0}/>
                        </Pagination>
                        <div className="ms-2">
                            <p>Mostrando {currentNumberOfElements} de {totalElements} </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }

    // Manejo de filtros
    const filtersContainer = () => {
        return (
            <Container>
                <Row className="mt-3 justify-content-center" xs={2} md={3}>
                    {/* Filtro por Nombre: Guarda el nombre del producto */}
                    <Col>
                        <Form.Group controlId="nameFilter">
                            <Form.Control
                                className="filtersStyle"
                                type="text"
                                placeholder="Buscar por nombre"
                                value={nameFilter}
                                onChange={(e) => setNameFilter(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    {/* Botones de Búsqueda y Limpiar */}
                    <Col className="text-center text-md-start mt-3 mt-md-0 mb-sm-3 mb-md-0">
                        <Button id="btnSearchProduct" className="me-1" variant="primary" onClick={() => getPage()}>
                            <Search/>
                        </Button>
                        <Button id="btnCleanSearchProducts" className="ms-1" variant="primary" onClick={() => cleanFilters()}>
                            <CloseLarge/>
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const cleanFilters = () => {
        setNameFilter("");
        setIsLoading(true);
        getPage();
    }

    const modalControlButtons = () => {
        return (
            <Container className="mt-3">
                <Row>
                    <Col className="text-alig-center">
                        <Button variant="primary" className="me-1"
                                onClick={() => setShowModalAddShopBranch(true)}>Agregar Sucursal</Button>
                    </Col>
                </Row>
            </Container>
        )
    }

    const addShopBranchModal = () => {
        return (
            <Modal className="modal fade modal-lg" show={showModalAddShopBranch} onHide={() => setShowModalAddShopBranch(false)}>
                <Modal.Header className="modal-header">
                    <h1 className="modal-title fs-5 titleModalCreateProduct" id="modaleAddProductLabel">
                        Nueva sucursal
                    </h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            onClick={() => {
                                setErrorsShopBranch({
                                    nameShopBranch: false,
                                    registeredNameShopBranch: false,
                                    addressShopBranch: false,
                                    provinceShopBranch: false,
                                    cityShopBranch: false,
                                });
                                setNameShopBranch('');
                                setRegisteredNameShopBranch('')
                                setAddressShopBranch('')
                                setPhoneNumberShopBranch('')
                                setProvinceShopBranch('')
                                setCityShopBranch('')
                                setShowModalAddShopBranch(false);
                            }}></button>
                </Modal.Header>
                <Modal.Body className="modal-body">
                    {/* Campo de Cantidad de Stock */}
                    <div className="mb-3">
                        <label htmlFor="nombreShopBranch" className="col-form-label">Nombre:</label>
                        <input type="text" className={`form-control ${errorsShopBranch.nameShopBranch ? 'is-invalid' : ''}`}
                               id="nombreShopBranch" value={nameShopBranch}
                               onChange={(e) => setNameShopBranch(e.target.value)}/>
                        {errorsShopBranch.nameShopBranch && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="registeredName" className="col-form-label">Razón social:</label>
                        <input type="text" className={`form-control ${errorsShopBranch.registeredNameShopBranch ? 'is-invalid' : ''}`}
                               id="registeredName" value={registeredNameShopBranch}
                               onChange={(e) => setRegisteredNameShopBranch(e.target.value)}/>
                        {errorsShopBranch.registeredNameShopBranch && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="adress" className="col-form-label">Domicilio:</label>
                        <input type="text" className={`form-control ${errorsShopBranch.addressShopBranch ? 'is-invalid' : ''}`}
                               id="address" value={addressShopBranch}
                               onChange={(e) => setAddressShopBranch(e.target.value)}/>
                        {errorsShopBranch.addressShopBranch && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="phoneNumber" className="col-form-label">Numero de telefono:</label>
                        <input type="number" className={`form-control ${errorsShopBranch.phoneNumberShopBranch ? 'is-invalid' : ''}`}
                               id="phoneNumber" value={phoneNumberShopBranch}
                               onChange={(e) => setPhoneNumberShopBranch(e.target.value)}/>
                        {errorsShopBranch.phoneNumberShopBranch && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="province" className="col-form-label">Provincia:</label>
                        <input type="text" className={`form-control ${errorsShopBranch.provinceShopBranch ? 'is-invalid' : ''}`}
                               id="province" value={provinceShopBranch}
                               onChange={(e) => setProvinceShopBranch(e.target.value)}/>
                        {errorsShopBranch.provinceShopBranch && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="cityShopBranch" className="col-form-label">Ciudad:</label>
                        <input type="text" className={`form-control ${errorsShopBranch.cityShopBranch ? 'is-invalid' : ''}`}
                               id="cityShopBranch" value={cityShopBranch}
                               onChange={(e) => setCityShopBranch(e.target.value)}/>
                        {errorsShopBranch.cityShopBranch && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => {
                        setErrorsShopBranch({
                            nameShopBranch: false,
                            registeredNameShopBranch: false,
                            addressShopBranch: false,
                            provinceShopBranch: false,
                            cityShopBranch: false,
                        });
                        setNameShopBranch('');
                        setRegisteredNameShopBranch('')
                        setAddressShopBranch('')
                        setPhoneNumberShopBranch('')
                        setProvinceShopBranch('')
                        setCityShopBranch('')
                        setShowModalAddShopBranch(false);
                    }}>
                        Cerrar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={handleSaveShopBranch}>
                        Guardar
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }

    const handleSaveShopBranch = () => {
        if (validateFields()) {
            saveShopBranch(); // Llamar a la función para guardar si no hay errores
        }
    };

    const handleEditShopBranch = () => {
        if (validateFieldsEdit()) {
            editShopBranch(); // Llamar a la función para guardar si no hay errores
        }
    };

    const validateFields = () => {
        const newErrorsShopBranch = {
            nameShopBranch: nameShopBranch == '',
            registeredNameShopBranch: registeredNameShopBranch == '',
            addressShopBranch: addressShopBranch == '',
            provinceShopBranch: provinceShopBranch == '',
            cityShopBranch: cityShopBranch == '',
        };
        setErrorsShopBranch(newErrorsShopBranch);

        // Retornar true si no hay errores
        return !Object.values(newErrorsShopBranch).includes(true);
    };

    const validateFieldsEdit = () => {
        const newErrorsShopBranchEdit = {
            nameShopBranchEdit: nameShopBranchEdit == '',
            registeredNameShopBranchEdit: registeredNameShopBranchEdit == '',
            addressShopBranchEdit: addressShopBranchEdit == '',
            provinceShopBranchEdit: provinceShopBranchEdit == '',
            cityShopBranchEdit: cityShopBranchEdit == '',
        };
        setErrorsShopBranchEdit(newErrorsShopBranchEdit);

        // Retornar true si no hay errores
        return !Object.values(newErrorsShopBranchEdit).includes(true);
    };

    const saveShopBranch = () => {
        const shopBranchDTO = {
            name: nameShopBranch,
            registeredName: registeredNameShopBranch,
            address: addressShopBranch,
            phoneNumber: phoneNumberShopBranch,
            province: provinceShopBranch,
            city: cityShopBranch,
        }
        axios.post(process.env.REACT_APP_API_SHOP_BRANCH_ROUTE, shopBranchDTO, {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            }
        })
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Creado correctamente.',
                    timer: 1500,
                    showConfirmButton: false,
                });
                setNameShopBranch('');
                setRegisteredNameShopBranch('')
                setAddressShopBranch('')
                setPhoneNumberShopBranch('')
                setProvinceShopBranch('')
                setCityShopBranch('')
                setShowModalAddShopBranch(false);
                getPage();
            })
            .catch(error => {
                const errorMessage = error.response?.data.message || 'Ocurrió un error inesperado';
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage,
                    confirmButtonText: 'Cerrar',
                });
            });
    }

    const editShopBranch = () => {
        const shopBranchDTO = {
            id: idShopBranchEdit,
            name: nameShopBranchEdit,
            registeredName: registeredNameShopBranchEdit,
            address: addressShopBranchEdit,
            phoneNumber: phoneNumberShopBranchEdit,
            province: provinceShopBranchEdit,
            city: cityShopBranchEdit,
        }
        axios.put(process.env.REACT_APP_API_SHOP_BRANCH_ROUTE, shopBranchDTO, {
            withCredentials: true,
            headers: {
                Authorization: localStorage.getItem(keyLocalStorage),
            }
        })
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Editado correctamente.',
                    timer: 1500,
                    showConfirmButton: false,
                });
                setIdShopBranchEdit('');
                setNameShopBranchEdit('');
                setRegisteredNameShopBranchEdit('')
                setAddressShopBranchEdit('')
                setPhoneNumberShopBranchEdit('')
                setProvinceShopBranchEdit('')
                setCityShopBranchEdit('')
                setShowModalEditShopBranch(false);
                getPage();
            })
            .catch(error => {
                const errorMessage = error.response?.data.message || 'Ocurrió un error inesperado';
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage,
                    confirmButtonText: 'Cerrar',
                });
            });
    }

    const editShopBranchModal = () => {
        return (
            <Modal className="modal fade modal-lg" show={showModalEditShopBranch} onHide={() => setShowModalEditShopBranch(false)}>
                <Modal.Header className="modal-header">
                    <h1 className="modal-title fs-5 titleModalCreateProduct" id="modaleAddProductLabel">
                        Editando sucursal
                    </h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            onClick={() => {
                                setErrorsShopBranchEdit({
                                    nameShopBranchEdit: false,
                                    registeredNameShopBranchEdit: false,
                                    addressShopBranchEdit: false,
                                    provinceShopBranchEdit: false,
                                    cityShopBranchEdit: false,
                                });
                                setIdShopBranchEdit('');
                                setNameShopBranchEdit('');
                                setRegisteredNameShopBranchEdit('')
                                setAddressShopBranchEdit('')
                                setPhoneNumberShopBranchEdit('')
                                setProvinceShopBranchEdit('')
                                setCityShopBranchEdit('')
                                setShowModalEditShopBranch(false);
                            }}></button>
                </Modal.Header>
                <Modal.Body className="modal-body">
                    {/* Campo de Cantidad de Stock */}
                    <div className="mb-3">
                        <label htmlFor="nombreShopBranchEdit" className="col-form-label">Nombre:</label>
                        <input type="text" className={`form-control ${errorsShopBranchEdit.nameShopBranchEdit ? 'is-invalid' : ''}`}
                               id="nombreShopBranchEdit" value={nameShopBranchEdit}
                               onChange={(e) => setNameShopBranchEdit(e.target.value)}/>
                        {errorsShopBranchEdit.nameShopBranchEdit && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="registeredNameEdit" className="col-form-label">Razón social:</label>
                        <input type="text" className={`form-control ${errorsShopBranchEdit.registeredNameShopBranchEdit ? 'is-invalid' : ''}`}
                               id="registeredNameEdit" value={registeredNameShopBranchEdit}
                               onChange={(e) => setRegisteredNameShopBranchEdit(e.target.value)}/>
                        {errorsShopBranchEdit.registeredNameShopBranchEdit && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="adressEdit" className="col-form-label">Direccion:</label>
                        <input type="text" className={`form-control ${errorsShopBranchEdit.addressShopBranchEdit ? 'is-invalid' : ''}`}
                               id="addressEdit" value={addressShopBranchEdit}
                               onChange={(e) => setAddressShopBranchEdit(e.target.value)}/>
                        {errorsShopBranchEdit.addressShopBranchEdit && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="phoneNumberEdit" className="col-form-label">Numero de telefono:</label>
                        <input type="number" className={`form-control ${errorsShopBranchEdit.phoneNumberShopBranchEdit ? 'is-invalid' : ''}`}
                               id="phoneNumberEdit" value={phoneNumberShopBranchEdit}
                               onChange={(e) => setPhoneNumberShopBranchEdit(e.target.value)}/>
                        {errorsShopBranchEdit.phoneNumberShopBranchEdit && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="provinceEdit" className="col-form-label">Provinvia:</label>
                        <input type="text" className={`form-control ${errorsShopBranchEdit.provinceShopBranchEdit ? 'is-invalid' : ''}`}
                               id="provinceEdit" value={provinceShopBranchEdit}
                               onChange={(e) => setProvinceShopBranchEdit(e.target.value)}/>
                        {errorsShopBranchEdit.provinceShopBranchEdit && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="cityShopBranchEdit" className="col-form-label">Ciudad:</label>
                        <input type="text" className={`form-control ${errorsShopBranchEdit.cityShopBranchEdit ? 'is-invalid' : ''}`}
                               id="cityShopBranchEdit" value={cityShopBranchEdit}
                               onChange={(e) => setCityShopBranchEdit(e.target.value)}/>
                        {errorsShopBranchEdit.cityShopBranchEdit && (
                            <div className="invalid-feedback">Campo obligatorio</div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => {
                        setErrorsShopBranchEdit({
                            nameShopBranchEdit: false,
                            registeredNameShopBranchEdit: false,
                            addressShopBranchEdit: false,
                            provinceShopBranchEdit: false,
                            cityShopBranchEdit: false,
                        });
                        setIdShopBranchEdit('');
                        setNameShopBranchEdit('');
                        setRegisteredNameShopBranchEdit('')
                        setAddressShopBranchEdit('')
                        setPhoneNumberShopBranchEdit('')
                        setProvinceShopBranchEdit('')
                        setCityShopBranchEdit('')
                        setShowModalEditShopBranch(false);
                    }}>
                        Cerrar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={handleEditShopBranch}>
                        Guardar
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }

    const editShopBranchField = (shopBranch) => {
        setIdShopBranchEdit(shopBranch.id);
        setNameShopBranchEdit(shopBranch.name);
        setRegisteredNameShopBranchEdit(shopBranch.registeredName)
        setAddressShopBranchEdit(shopBranch.address)
        setPhoneNumberShopBranchEdit(shopBranch.phoneNumber)
        setProvinceShopBranchEdit(shopBranch.province)
        setCityShopBranchEdit(shopBranch.city)
    }

    const loadingTable = () => {
        return (
            <>
                <div className="m-3">
                    <Table responsive className="table-striped">
                        <thead className="tableHead">
                        <tr>
                            <th>Nombre</th>
                            <th>Razón social</th>
                            <th>Direccion</th>
                            <th>Numero de telefono</th>
                            <th>Provincia / Ciudad</th>
                            <th style={{width: '5%'}}></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colSpan="3" className="backgroundTable text-center">
                                <div className="loader-container-listado">
                                    <div className="loader"></div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </>
        )
    }

    return (
        <>
            {loading ? (
                <Loading/>
            ) : (
                <div style={{marginLeft: '50px'}}>
                    <div style={{ border: '2px solid darkGray', borderRadius: '8px', padding: '16px', marginTop: '1%', marginLeft: '5%', marginBottom: '5%', marginRight: '5%' }}>
                        <Container className='mt-3'>
                            <Row>
                                <Col xs={12}>
                                    <h1 className="titleShop">Local</h1>
                                    <h2 className="identificationNumber">Numero de identificacion: {shopDTO.identificationNumber}</h2>
                                </Col>
                            </Row>
                        </Container>
                        <Container className="mt-3">
                            <Form>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3" controlId="formShopName">
                                            <Form.Label>Nombre de tienda</Form.Label>
                                            <Form.Control type="text" placeholder="Ingrese nombre de tienda" value={shopDTO.name} disabled/>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3" controlId="formShopName">
                                            <Form.Label>Razon Social</Form.Label>
                                            <Form.Control type="text" placeholder="Ingrese nombre de tienda" value={shopDTO.businessName} disabled/>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3" controlId="formShopName">
                                            <Form.Label>Teléfono</Form.Label>
                                            <Form.Control type="text" placeholder="Ingrese nombre de tienda" value={shopDTO.phone} disabled/>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3" controlId="formShopName">
                                            <Form.Label>Dirección</Form.Label>
                                            <Form.Control type="text" placeholder="Ingrese nombre de tienda" value={shopDTO.address} disabled/>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3" controlId="formShopName">
                                            <Form.Label>Localidad</Form.Label>
                                            <Form.Control type="text" placeholder="Ingrese nombre de tienda" value={shopDTO.state} disabled/>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3" controlId="formShopName">
                                            <Form.Label>Provincia</Form.Label>
                                            <Form.Control type="text" placeholder="Ingrese nombre de tienda" value={shopDTO.location} disabled/>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={{span: 2, offset: 10}} className="d-flex justify-content-end">
                                        <Button variant="primary" onClick={handleShowModal}>
                                            Editar datos
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </div>
                    <div style={{ border: '2px solid darkGray', borderRadius: '8px', padding: '16px', margin: '5%' }}>
                        <Container>
                            <Row>
                                <Col xs={12}>
                                    <h1 className="titleShop">Sucursales</h1>
                                </Col>
                                {(isLoading) ? (
                                    loadingTable()
                                ) : (
                                <div className="m-3">
                                    <Table responsive className="table-striped">
                                        <thead className="tableHead">
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Razón social</th>
                                            <th>Direccion</th>
                                            <th>Numero de telefono</th>
                                            <th>Provincia / Ciudad</th>
                                            <th style={{width: '5%'}}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {shopBranch.length > 0 ? (
                                            shopBranch.map(shopBranch => (
                                                <tr key={shopBranch.id}>
                                                    <td className="text-alig-center">{shopBranch.name}</td>
                                                    <td className="text-alig-center">{shopBranch.registeredName}</td>
                                                    <td className="text-alig-center">{shopBranch.address}</td>
                                                    <td className="text-alig-center">{shopBranch.phoneNumber}</td>
                                                    <td className="text-alig-center">{shopBranch.province} / {shopBranch.city}</td>
                                                    <td className="text-alig-center">
                                                        <div style={{display: "flex"}}>
                                                            <button
                                                                className="btn btnCopy"
                                                                data-test-cy="btnCopyId"
                                                                title={`ID: ${shopBranch.id}`}
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(shopBranch.id.toString());
                                                                    Swal.fire({
                                                                        icon: 'success',
                                                                        title: '¡Copiado!',
                                                                        text: 'ID copiado al portapapeles',
                                                                        timer: 1500,
                                                                        showConfirmButton: false
                                                                    });
                                                                }}
                                                            >
                                                                <FiCopy size="20"/>
                                                            </button>
                                                            <button className="btn btnEdit" data-test-cy="btnEditLocation">
                                                                <RequestQuote
                                                                    className="btnEdit"
                                                                    size="24"
                                                                    onClick={() => {
                                                                        editShopBranchField(shopBranch);
                                                                        setShowModalEditShopBranch(true);
                                                                    }}
                                                                />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center" colSpan="7">Aún no hay sucursales cargadas</td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </Table>
                                </div>
                                )}
                            </Row>
                            {paginationModule()}
                        </Container>
                        {modalControlButtons()}
                        {addShopBranchModal()}
                        {editShopBranchModal()}
                    </div>
                </div>

            )}

            <Modal show={show} onHide={handleCloseModal} backdrop="static" keyboard={false} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Editar datos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <Form.Group className="mb-3" controlId="formShopName">
                                    <Form.Label>Nombre de tienda</Form.Label>
                                    <Form.Control
                                        data-test-cy="formShopName"
                                        type="text"
                                        placeholder="Ingrese nombre de tienda"
                                        value={editShopDTO.name}
                                        onChange={(e) =>
                                            setEditShopDTO({
                                                ...editShopDTO,
                                                name: e.target.value,
                                            })
                                        }
                                    />
                                    {errors.name && <span className="text-danger">{errors.name}</span>}
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <Form.Group className="mb-3" controlId="formBusinessName">
                                    <Form.Label>Razón Social</Form.Label>
                                    <Form.Control
                                        data-test-cy="formBusinessName"
                                        type="text"
                                        placeholder="Ingrese nombre de tienda"
                                        value={editShopDTO.businessName}
                                        onChange={(e) =>
                                            setEditShopDTO({
                                                ...editShopDTO,
                                                businessName: e.target.value,
                                            })
                                        }
                                    />
                                    {errors.businessName && <span className="text-danger">{errors.businessName}</span>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <Form.Group className="mb-3" controlId="formPhone">
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control
                                        data-test-cy="formPhone"
                                        type="text"
                                        placeholder="Ingrese teléfono"
                                        value={editShopDTO.phone}
                                        onChange={(e) =>
                                            setEditShopDTO({
                                                ...editShopDTO,
                                                phone: e.target.value,
                                            })
                                        }
                                    />
                                    {errors.phone && <span className="text-danger">{errors.phone}</span>}
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <Form.Group className="mb-3" controlId="formAddress">
                                    <Form.Label>Dirección</Form.Label>
                                    <Form.Control
                                        data-test-cy="formAddress"
                                        type="text"
                                        placeholder="Ingrese dirección"
                                        value={editShopDTO.address}
                                        onChange={(e) =>
                                            setEditShopDTO({
                                                ...editShopDTO,
                                                address: e.target.value,
                                            })
                                        }
                                    />
                                    {errors.address && <span className="text-danger">{errors.address}</span>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <Form.Group className="mb-3" controlId="formState">
                                    <Form.Label>Localidad</Form.Label>
                                    <Form.Control
                                        data-test-cy="formState"
                                        type="text"
                                        placeholder="Ingrese localidad"
                                        value={editShopDTO.state}
                                        onChange={(e) =>
                                            setEditShopDTO({
                                                ...editShopDTO,
                                                state: e.target.value,
                                            })
                                        }
                                    />
                                    {errors.state && <span className="text-danger">{errors.state}</span>}
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={6}>
                                <Form.Group className="mb-3" controlId="formLocation">
                                    <Form.Label>Provincia</Form.Label>
                                    <Form.Control
                                        data-test-cy="formLocation"
                                        type="text"
                                        placeholder="Ingrese provincia"
                                        value={editShopDTO.location}
                                        onChange={(e) =>
                                            setEditShopDTO({
                                                ...editShopDTO,
                                                location: e.target.value,
                                            })
                                        }
                                    />
                                    {errors.location && <span className="text-danger">{errors.location}</span>}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Cerrar</Button>
                    <Button variant="primary" onClick={handleSubmit}>Guardar datos</Button>
                </Modal.Footer>
            </Modal>

        </>
    );
}